export default __webpack_public_path__ + "static/media/displayname.5788c5d7.png";